import { update } from './update';

export function request(email, password) {
    return {
        type: 'USER_LOGIN_REQUEST',
        email,
        password
    };
}

export function error(errors) {
    return {
        type: 'USER_LOGIN_ERROR',
        errors
    };
}

export function finish(data) {
    return (dispatch) => {
        dispatch(update(data));

        dispatch({
            type: 'USER_LOGIN_FINISH'
        });
    };
}

export function clear() {
    return {
        type: 'USER_LOGIN_CLEAR'
    };
}
